<template>
  <div id="side-container" :class="{ 'sidebar-collapsed': collapsed }">
    <div id="sidebar" :class="{ 'sidebar-collapsed': collapsed }" v-click-outside="closeDropRight">
      <div class="subbar anotherhand">Ikleeralles.nl</div>
      <slot name="links" />
      <span class="category">Vakken</span>
      <a @click="redirectEnvironment('woordjes')">
        <b-icon icon="translate" />
        <span class="link-text">Woordjes</span>
      </a>
      <a @click="redirectEnvironment('wiskunde')">
        <b-icon icon="calculator-variant-outline" />
        <span class="link-text">Wiskunde</span>
        <b-tag>Beta</b-tag>
      </a>
      <!-- <a @click="closeDropRight">
        <b-icon icon="pin-outline" />
        <span class="link-text">Topografie</span>
      </a> -->
      <span class="category">Community</span>
      <a @click="redirectDiscord()">
        <b-icon icon="discord" />
        <span class="link-text">Discord</span>
      </a>
      <div id="collapse" class="hoverable" @click="collapse()">
        <b-icon :icon="collapsed ? 'chevron-right' : 'chevron-left'" />
      </div>
    </div>
    <transition name="fade">
      <div v-show="collapsedDropRight" id="drop-right" :class="{ 'dropright-collapsed': collapsed }">
        <div v-if="dropRightEntity == 'folder'">
          <div class="columns is-mobile">
            <div class="column">
              <h2 class="title is-5">Mappen</h2>
            </div>
            <div class="column has-text-right">
              <b-icon @click.native="confirmCreateFolder()" icon="plus" class="hoverable" />
            </div>
          </div>
          <router-link v-for="folder in folders" :key="folder.id" :to="'/folder/' + folder.id" @click.native="closeDropRight">
            <b-icon icon="folder-outline" />
            <span class="link-text">{{ folder.name }}</span>
          </router-link>
        </div>
        <div v-if="dropRightEntity == 'group'">
          <div class="columns is-mobile">
            <div class="column">
              <h2 class="title is-5">Groepen</h2>
            </div>
            <div class="column has-text-right">
              <b-icon @click.native="confirmCreateGroup()" icon="plus" class="hoverable" />
            </div>
          </div>
          <router-link v-for="group in groups" :key="group.id" :to="'/group/' + group.id" @click.native="closeDropRight">
            <b-icon icon="account-multiple-outline" />
            <span class="link-text">{{ group.name }}</span>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { EventBus } from "./common/event-bus";
import ApiService from "./common/api.service";

export default {
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapsedDropRight: false,
      dropRightEntity: null,
    };
  },
  mounted() {
    EventBus.$on("collapseSidebar", (collapse) => {
      this.collapse(collapse);
    });
  },
  methods: {
    redirectSearch() {
      this.$router.push("/search");
    },
    collapse(collapse) {
      this.collapsed = collapse
      this.$emit("collapseSidebar", this.collapsed);
    },
    confirmCreateFolder() {
      this.$buefy.dialog.prompt({
        message: "Naam",
        trapFocus: true,
        confirmText: "Maken",
        onConfirm: (name) => this.createFolder(name),
      });
    },
    async createFolder(name) {
      const loadingComponent = this.$buefy.loading.open()

      const response = await ApiService.post("folder", { name: name }, true);
      await this.$store.dispatch("user/refreshFolders");

      loadingComponent.close()
      this.$buefy.toast.open({
        message: "De map is aangemaakt",
        type: "is-success",
        position: "is-bottom-right",
      });

      return this.$router.push(`/folder/${response.data.id}`);
    },
    confirmCreateGroup() {
      this.$buefy.dialog.prompt({
        message: "Naam",
        trapFocus: true,
        confirmText: "Maken",
        onConfirm: (name) => this.createGroup(name),
      });
    },
    async createGroup(name) {
      const loadingComponent = this.$buefy.loading.open()

      const response = await ApiService.post("group", { name }, true);
      await this.$store.dispatch("user/refreshGroups");

      loadingComponent.close()
      this.$buefy.toast.open({
        message: "Je groep is aangemaakt",
        type: "is-success",
        position: "is-bottom-right",
      });

      return this.$router.push(`/group/${response.data.id}`);
    },
    dropRightContent(entity) {
      if (!this.dropRightEntity || !entity || this.dropRightEntity == entity) {
        this.collapsedDropRight = !this.collapsedDropRight;
      }
      this.dropRightEntity = entity;

      if (!this.collapsedDropRight) {
        this.dropRightEntity = null;
      }
    },
    closeDropRight() {
      this.collapsedDropRight = false;
      this.dropRightEntity = null;
    },
    redirectEnvironment(environment) {
      window.location.href = `https://${environment}.ikleeralles.nl`
    },
    redirectDiscord() {
      window.location.href = 'https://discord.com/invite/E5deFVJKgu'
    }
  },
  computed: {
    folders() {
      return this.$store.state.user.folders;
    },
    groups() {
      return this.$store.state.user.groups;
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin collapse {
  width: 40px;
  padding: 0;
  &::v-deep .link-text {
    display: none !important;
  }
  &::v-deep .category {
    opacity: 0 !important;
  }
  &::v-deep a {
    padding: 5px 10px !important;
    .icon {
      margin: 0 auto;
    }
  }
  .subbar {
    opacity: 0;
  }
  &::v-deep .tag {
    display: none;
  }
}
#side-container {
  height: 100vh;
  width: 250px;
  position: fixed;
  z-index: 50;
  @media only screen and (max-width: 1000px) {
    width: 40px;
  }
  &.sidebar-collapsed {
    width: 40px;
  }
  #sidebar {
    width: 250px;
    height: 100%;
    position: fixed;
    z-index: 51;
    top: 0;
    left: 0;
    background-color: #fff;
    padding: 0 20px;
    transition: all 0.3s;
    &.sidebar-collapsed {
      @include collapse;
    }
    @media only screen and (max-width: 1000px) {
      @include collapse;
    }
    .subbar {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 2rem;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
    }
    .b-tooltip {
      width: 100%;
    }
    a {
      color: #9b9b9b;
      padding: 5px 20px;
      display: flex;
      align-items: center;
      height: 35px;
      width: 100%;
      font-size: 0.9rem;
      &:hover {
        background: #f2f2f2;
        border-radius: 10px;
        color: #3e3e3e;
      }
      &.router-link-exact-active {
        background: #007aff;
        color: #fff;
        border-radius: 10px;
      }
      .icon {
        margin-right: .75rem;
      }
      .link-text {
        display: flex;
        flex-direction: column;
      }
      .tag {
        margin-left: 5px;
      }
    }
    .category {
      text-transform: uppercase;
      color: #c6c6c6;
      margin: 20px 0 10px 0;
      display: flex;
      align-items: center;
    }
    #collapse {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 80px;
      right: -15px;
      color: #000;
      background: #fff;
      width: 30px;
      height: 30px;
      border-radius: 100%;
      -webkit-box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
      box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
      &:hover {
        cursor: pointer;
      }
      @media only screen and (max-width: 1000px) {
        display: none;
      }
    }
  }
  #drop-right {
    height: 100%;
    width: 250px;
    overflow: auto;
    -webkit-backdrop-filter: blur(15px);
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, 0.5);
    position: absolute;
    left: 250px;
    padding: 20px;
    transition: all 0.5s;
    opacity: 1;
    box-shadow: 3px 0px 2px 0 rgb(0 0 0 / 20%);
    a {
      margin: 2px 0;
      color: #3e3e3e;
      padding: 5px 10px;
      display: flex;
      align-items: center;
      width: 100%;
      overflow: hidden;
      .icon {
        margin-right: .75rem;
      }
      &:hover {
        background: #fff;
        border-radius: 5px;
      }
    }
    .title {
      color: #3e3e3e;
      margin-bottom: 0;
    }
    @media only screen and (max-width: 1000px) {
      left: 40px;
    }
    &.dropright-collapsed {
      left: 40px;
    }
  }
  .fade-enter,
  .fade-leave-to {
    transform: translateX(-250px);
  }

  .fade-enter-to,
  .fade-leave {
    transform: translateX(0);
  }
}
</style>
